import { IconButton, Tooltip } from '@mui/material';
import { Create as IconCreate } from '@mui/icons-material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import EditEmailDialog from './EditEmailDialog';
import TestIds from 'Tests/TestIds';

interface Props {
  person: IPersonWithAccount;
  onCompleted?: () => void;
  organizationCode?: string;
}

interface State {
  isDialogOpen: boolean;
}

class EditEmailToggle extends React.Component<Props, State> {
  public readonly state: State = {
    isDialogOpen: false
  };

  public render() {
    const { person, onCompleted, organizationCode } = this.props;
    const { isDialogOpen } = this.state;

    return <>
      <Tooltip
        title={<FormattedMessage id="common.action.edit" />}
        placement="bottom"
      >
        <IconButton
          onClick={this.onOpenDialog}
          data-testid={TestIds.pages.profile.editEmailButton}
          size="large">
          <IconCreate />
        </IconButton>
      </Tooltip>
      {isDialogOpen && (
        <EditEmailDialog
          person={person}
          organizationCode={organizationCode}
          onCompleted={onCompleted ?? (() => {})}
          onClose={this.onCloseDialog}
        />
      )}
    </>;
  }

  private onOpenDialog = () => {
    this.setState({
      isDialogOpen: true
    });
  };

  private onCloseDialog = () => {
    this.setState({
      isDialogOpen: false
    });
  };
}

export default EditEmailToggle;
